// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-button4 {
    
  border: none;
  background-color: #e9766b;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
}

.submit-button4:hover {
  outline: none;
  background-color: #e9766b;
}


.action-button-danger {
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: 1px solid rgb(236, 26, 26);
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-success{
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: #8bc34a;
    border: 1px solid #8bc34a;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-danger-without-border{
    padding: 2px 3px;
    margin-right: 5px; 
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-danger-without-border:hover{
    background-color: rgba(150, 214, 241, 0.87);
  }

  .action-button-success:hover{
    background-color: #8bc34a;
    color: white;
  }
  
  .action-button-danger:hover {
    background-color: rgb(236, 26, 26);
    color: white;
  }

.styled-table-rcsa {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.styled-table-rcsa thead tr {
  background-color: #000000; /* Black header */
  color: #ffffff;
  text-align: left;
}

.styled-table-rcsa th,
.styled-table-rcsa td {
  padding: 12px 15px;
  border: 1px solid #dddddd;
  vertical-align: top;
}

.styled-table-rcsa tbody tr {
  border-bottom: 1px solid #dddddd;
}

.styled-table-rcsa tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.styled-table-rcsa tbody tr:last-of-type {
  border-bottom: 2px solid #000000; /* Black border */
}




.styled-table-rcsa td:nth-child(1) {
  background-color: #d0b162; /* Light gray for Function */
}


.styled-table-rcsa td:nth-child(2) {
  background-color: #f2e9d2; /* Slightly darker gray for Domain */
}



.styled-table-rcsa tbody tr.active-row {
  font-weight: bold;
  color: #b22222; /* Dark red color */
}


.submit-button5 {
    
  background-color: transparent;
  border: 1px solid #ff6f61;
  color: #ff6f61;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
}

.submit-button5:hover {
  outline: none;
  background-color: #e65c54;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/RCSA/rcsa.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IAEjB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,kCAAkC;IAClC,YAAY;EACd;;AAEF;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,4DAA4D;EAC5D,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC,EAAE,iBAAiB;AACrD;;;;;AAKA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;;AAGA;EACE,yBAAyB,EAAE,oCAAoC;AACjE;;;;AAIA;EACE,iBAAiB;EACjB,cAAc,EAAE,mBAAmB;AACrC;;;AAGA;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".submit-button4 {\r\n    \r\n  border: none;\r\n  background-color: #e9766b;\r\n  color: white;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  outline: none;\r\n  height: 30px !important;\r\n}\r\n\r\n.submit-button4:hover {\r\n  outline: none;\r\n  background-color: #e9766b;\r\n}\r\n\r\n\r\n.action-button-danger {\r\n    padding: 3px 4px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: rgb(236, 26, 26);\r\n    border: 1px solid rgb(236, 26, 26);\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-success{\r\n    padding: 3px 4px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #8bc34a;\r\n    border: 1px solid #8bc34a;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-danger-without-border{\r\n    padding: 2px 3px;\r\n    margin-right: 5px;\r\n    border: none; \r\n    background-color: transparent;\r\n    color: rgb(236, 26, 26);\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-danger-without-border:hover{\r\n    background-color: rgba(150, 214, 241, 0.87);\r\n  }\r\n\r\n  .action-button-success:hover{\r\n    background-color: #8bc34a;\r\n    color: white;\r\n  }\r\n  \r\n  .action-button-danger:hover {\r\n    background-color: rgb(236, 26, 26);\r\n    color: white;\r\n  }\r\n\r\n.styled-table-rcsa {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin: 25px 0;\r\n  font-size: 0.9em;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.styled-table-rcsa thead tr {\r\n  background-color: #000000; /* Black header */\r\n  color: #ffffff;\r\n  text-align: left;\r\n}\r\n\r\n.styled-table-rcsa th,\r\n.styled-table-rcsa td {\r\n  padding: 12px 15px;\r\n  border: 1px solid #dddddd;\r\n  vertical-align: top;\r\n}\r\n\r\n.styled-table-rcsa tbody tr {\r\n  border-bottom: 1px solid #dddddd;\r\n}\r\n\r\n.styled-table-rcsa tbody tr:nth-of-type(even) {\r\n  background-color: #f3f3f3;\r\n}\r\n\r\n.styled-table-rcsa tbody tr:last-of-type {\r\n  border-bottom: 2px solid #000000; /* Black border */\r\n}\r\n\r\n\r\n\r\n\r\n.styled-table-rcsa td:nth-child(1) {\r\n  background-color: #d0b162; /* Light gray for Function */\r\n}\r\n\r\n\r\n.styled-table-rcsa td:nth-child(2) {\r\n  background-color: #f2e9d2; /* Slightly darker gray for Domain */\r\n}\r\n\r\n\r\n\r\n.styled-table-rcsa tbody tr.active-row {\r\n  font-weight: bold;\r\n  color: #b22222; /* Dark red color */\r\n}\r\n\r\n\r\n.submit-button5 {\r\n    \r\n  background-color: transparent;\r\n  border: 1px solid #ff6f61;\r\n  color: #ff6f61;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  outline: none;\r\n  height: 30px !important;\r\n}\r\n\r\n.submit-button5:hover {\r\n  outline: none;\r\n  background-color: #e65c54;\r\n  color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
